import App from '@/App.vue';
import vuetify from '@/plugins/vuetify';
import { createRouter } from '@/routing/router';
import { auth } from '@/server';
import store from '@/store/store';
import Vue from 'vue';
import Router from 'vue-router';
import { FirebaseUserService } from './Firebase/FirebaseCurrentUser';

Vue.config.productionTip = false;
Vue.use(Router);

let app: Vue | null = null;

auth.onAuthStateChanged((user) => {
  if (app) {
    return;
  }

  const router = createRouter(new FirebaseUserService(auth));
  app = new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount('#app');
});
